// extracted by mini-css-extract-plugin
module.exports = {"documentsContainer":"GroupGetStartedFeed_documentsContainer__jGXso","documentsContainer_bin":"GroupGetStartedFeed_documentsContainer_bin__3lBbg"};